import { SQUAD_FILTER_TYPE } from 'modules/squad/redux/constants'
import getMemberProductsByIdAndFilterTypeSquadSelector from 'modules/squad/redux/selectors/get-member-products-by-id-and-filter-type'

const hasSuperLikedProductsByMemberIdSquadSelector = id => state => {
  /**
   * @type {import('modules/squad/types').GetSquadProductsResp}
   */
  const data = getMemberProductsByIdAndFilterTypeSquadSelector(id, SQUAD_FILTER_TYPE.super_like)(state)

  return !!(
    data?.total_product_count
  )
}

export default hasSuperLikedProductsByMemberIdSquadSelector
